<template>
    <div>
        <header>
            <div v-if="rolePermission === '领导'">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addUsers">新增</el-button>
            </div>
        </header>
        <main>
            <div style="padding-bottom: 2px;">
                <el-table :data="list" height="calc(100vh - 116px)" :cell-style="rowStyle" id="tableId" ref="tableId"
                    min-width="30px" style="font-size:14px; flex-wrap: nowrap;  margin-top: 0px;" size="mini">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <el-table-column label="用户名" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-link v-if="rolePermission === '领导'" type="primary" @click="handleClick(scope.row)">{{ scope.row.userName }}</el-link>
                            <span v-else >{{ scope.row.userName }}</span>
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <!-- <span @click="handleClick(scope.row)" :class="{ hoverStyle: true }"
                                style="margin-left: 10px; cursor: pointer">{{ scope.row.userName
                                }}</span> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="角色" width="auto" align="center">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.role }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="业务组" width="auto" align="center">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.groupName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" width="auto" align="center">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.phone }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="钉钉ID" width="auto" align="center">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.dingtalkId }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="用户状态" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-switch @change="changeStatus(scope.row)" active-text="在职" inactive-text="离职"
                                v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-button round size="small" icon="el-icon-edit" type="warning"
                                @click="amendRow(scope.row)">修改</el-button>
                            <el-button plain size="small" icon="el-icon-delete" type="danger"
                                @click="deleteRow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
            <!-- 增加表单 -->
            <div>
                <el-dialog title="更新用户" :show-close="false" :close-on-click-modal="false"
                    :visible.sync="dialogFormVisible">
                    <el-form :model="obj" ref="obj" :rules="rules">
                        <el-form-item  label="用户名" prop="userName">
                            <el-input v-model="obj.userName" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" prop="phone">
                            <el-input v-model="obj.phone" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item  label="角色" prop="role">
                            <el-select style="width: 100%;" v-model="obj.role" placeholder="请选择">
                                <el-option v-for="item in RoleOptions" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <el-input v-model.trim="obj.role" autocomplete="off"></el-input> -->
                        </el-form-item>
                        <el-form-item  label="业务组" prop="groupName">
                            <el-select style="width: 100%;" v-model="obj.groupName" placeholder="请选择">
                                <el-option v-for="item in groupNameOptions" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <el-input v-model.trim="obj.role" autocomplete="off"></el-input> -->
                        </el-form-item>
                        <!-- <el-form-item required="true" label="钉钉ID" prop="dingtalkId">
                            <el-input v-model.trim="obj.dingtalkId" autocomplete="off"></el-input>
                        </el-form-item> -->
                        <el-form-item required="true" label="用户密码" prop="pwd">
                            <el-input v-model.trim="obj.pwd" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="cancel">取 消</el-button>
                        <el-button type="primary" @click="confirmChange('obj')">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
        </main>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
export default {
    name: 'stuffInformation',
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            list: [],
            status: true,//状态
            dialogFormVisible: false,
            groupNameOptions:[], // 业务组列表
            obj: {
                userName: '',//用户名
                phone: '',//电话
                groupName:'',
                pwd: '',//密码
                role: '',//角色
            },
            rules: {
                userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                role: [{ required: true, message: '请输入角色', trigger: 'blur' }],
                // phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
                groupName: [{ required: true, message: '请选择业务组', trigger: 'blur' }],
                // dingtalkId: [{ required: true, message: '请输入钉钉ID', trigger: 'blur' }],
                pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },
            RoleOptions: [],//角色信息
        }
    },
    created() {
        // this.userList();
        // this.getRoleList();
    },
    mounted() {
                this.userList();
        this.getRoleList();
        this.getGroupNameOptions();
    },
    methods: {
        // 查询业务组数据
        getGroupNameOptions(){
            let URL = `${url.getDicList}/?value=业务组`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.groupNameOptions= res.data.data.data;
                }
            })
        },
        rowStyle() {
            return "text-align:center";
        },
        userList() {
            let URL = `${url.getUserList}/`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.list = res.data.data;
                    this.computedStatus();
                }
            })
        },
        getRoleList() {
            let URL = `${url.getDicList}/?value=系统角色`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.RoleOptions= res.data.data.data;
                }
            })
        },
        //计算状态
        computedStatus() {
            for (const key in this.list) {
                if (this.list[key].status === 1) {
                    this.list[key].status = true;
                } else if (this.list[key].status === 0) {
                    this.list[key].status = false;
                }
            }
            return this.list;
        },
        // 开关状态
        changeStatus(row) {
            let URL = `${url.changeStatusUser}/${row.id}`;
            req.put(URL).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '变更成功!'
                    });
                    this.getData();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    });
                }
            })
        },
        addUsers() {
            this.obj = {
                userName: '',//用户名
                phone: '',//电话
                groupName:'',
                pwd: '',//密码
                role: '',//角色
            },
            this.dialogFormVisible = true;
        },
        // 确认新增
        confirmChange(obj) {
            this.$refs[obj].validate((valid) => {
                if (valid) {
                    this.reqAdd();
                } else {
                    this.$message({
                        type: 'error',
                        message: '请填写完毕所有信息!'
                    })
                    return false;
                }
            });

        },
        cancel() {
            this.obj = {
                userName: '',//用户名
                phone: '',//电话
                groupName:'',
                pwd: '',//密码
                role: '',//角色
            },
            this.dialogFormVisible = false;
            this.$refs.obj.resetFields();
        },
        //修改用户资料
        handleClick(row) {
            this.dialogFormVisible = true;
            this.obj.userName = row.userName;
            this.obj.phone = row.phone;
            // this.obj.dingtalkId = row.dingtalkId;
            this.obj.groupName = row.groupName;
            this.obj.pwd = row.pwd;
            this.obj.id = row.id;
            this.obj.role = row.role;
        },
        reqAdd() {
            let URL = `${url.saveOrUpdateUser}/`;
            req.post(URL, this.obj).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '新增成功'
                    })
                    this.userList();
                    this.obj.userName = '';
                    this.obj.phone = '';
                    // this.obj.dingtalkId = '';
                    this.obj.groupName = '';
                    this.obj.pwd = '';
                    this.obj.id = '';
                    this.obj.role = '';
                    this.dialogFormVisible = false;
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
    },
}
</script>

<style lang="css" scoped>
.hoverStyle:hover {
    color: blue;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}


::v-deep .cell {
    white-space: nowrap;
    /* overflow: auto; */
    display: inline-block;
}
</style>